"use client";
import { useEffect } from "react";
import { useUserStore } from "../../store/userStore";
import { userDetails } from "@/types";
import { User } from "@/app/(protected)/manage-users/types";

export default function UserDataProvider({ userData, children }: Readonly<{ userData: userDetails | User; children: React.ReactNode }>) {
  const setUserData = useUserStore((s) => s.setUserData);

  useEffect(() => {
    setUserData(userData);
  }, [userData, setUserData]);

  return <>{children}</>;
}
